import moment from 'moment'

import { DAYS_IN_WEEK } from './weekLayoutConstants'

export const computePercentLeft = (itemStart: string, rangeStart: string) => {
  const diff = moment(itemStart).diff(rangeStart, 'day', true)
  const ratio = diff / DAYS_IN_WEEK
  const absRatio = Math.max(ratio, 0)
  const percent = absRatio * 100
  return `${percent}%`
}
